<portal-context-switcher
  [entries]="queues"
  [hideArrow]="true"
  [labelTemplate]="label"
  [placeholder]="'acd.queue.breadcrumbSwitcher.placeholder' | translate"
  (valueChanged)="switchRoute($event)"
  switchParameter="queueId"
>
</portal-context-switcher>

<ng-template #label>
  <div class="nav-item__context" role="button">
    <span class="text-truncate">{{ queue.name }}</span>
    <i class="far fa-angle-down nav-item__context-icon"></i>
  </div>
</ng-template>
